import request from '../../utils/request.js'
export function getHotProblem(){
    return request({
        url:"/appInfo/getBankAndStock",
        method:'get',
    })
}
